/**
 * @flow
 * @relayHash dc79c13d840f6b102cc6ca1dc0f7cb8b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ProductWhere = {|
  and?: ?$ReadOnlyArray<?ProductWhere>,
  or?: ?$ReadOnlyArray<?ProductWhere>,
  id?: ?ConditionInputType,
  code?: ?ConditionInputType,
  name?: ?ConditionInputType,
  description?: ?ConditionInputType,
  hasVariablePrice?: ?ConditionInputType,
  price?: ?ConditionInputType,
  isInternet?: ?ConditionInputType,
  requiresCpe?: ?ConditionInputType,
  isAsistencia?: ?ConditionInputType,
  uploadSpeed?: ?ConditionInputType,
  downloadSpeed?: ?ConditionInputType,
  isDisabled?: ?ConditionInputType,
  displayName?: ?ConditionInputType,
  isService?: ?ConditionInputType,
  isConsumo?: ?ConditionInputType,
  accountId?: ?ConditionInputType,
  type?: ?ConditionInputType,
  createdAt?: ?ConditionInputType,
  createdBy?: ?ConditionInputType,
  hasDigital?: ?ConditionInputType,
  hasCatv?: ?ConditionInputType,
  familyId?: ?ConditionInputType,
  subscriptions?: ?ConditionInputType,
|};
export type ConditionInputType = {|
  eq?: ?string,
  ne?: ?string,
  gt?: ?string,
  gte?: ?string,
  lt?: ?string,
  lte?: ?string,
  is?: ?string,
  not?: ?string,
  in?: ?$ReadOnlyArray<?string>,
  notIn?: ?$ReadOnlyArray<?string>,
  like?: ?string,
  notLike?: ?string,
  iLike?: ?string,
  insub?: ?string,
|};
export type ProductContextQueryVariables = {|
  where?: ?ProductWhere
|};
export type ProductContextQueryResponse = {|
  +products: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: string,
        +isService: ?boolean,
        +hasDigital: ?boolean,
        +price: ?number,
      |}
    |}>
  |}
|};
export type ProductContextQuery = {|
  variables: ProductContextQueryVariables,
  response: ProductContextQueryResponse,
|};
*/


/*
query ProductContextQuery(
  $where: ProductWhere
) {
  products(where: $where, orderBy: [code], order: ASC) {
    edges {
      node {
        id
        name
        isService
        hasDigital
        price
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "where",
    "type": "ProductWhere",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "products",
    "storageKey": null,
    "args": [
      {
        "kind": "Literal",
        "name": "order",
        "value": "ASC"
      },
      {
        "kind": "Literal",
        "name": "orderBy",
        "value": [
          "code"
        ]
      },
      {
        "kind": "Variable",
        "name": "where",
        "variableName": "where"
      }
    ],
    "concreteType": "ProductConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "ProductEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Product",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isService",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasDigital",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "price",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ProductContextQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ProductContextQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "ProductContextQuery",
    "id": null,
    "text": "query ProductContextQuery(\n  $where: ProductWhere\n) {\n  products(where: $where, orderBy: [code], order: ASC) {\n    edges {\n      node {\n        id\n        name\n        isService\n        hasDigital\n        price\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5d8c2d50b53f6e4ec0dffa32824866be';
module.exports = node;
